"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NAICS_INDUSTRY_GROUP_SELECT_OPTIONS = exports.NAICS_INDUSTRY_GROUP_OPTIONS = exports.NAICSCode = void 0;
const legacy_ui_1 = require("@hum/legacy-ui");
var NAICSCode;
(function (NAICSCode) {
    NAICSCode["AgricultureForestry"] = "agriculture_forestry_fishing_and_hunting";
    NAICSCode["Mining"] = "mining";
    NAICSCode["Utilities"] = "utilities";
    NAICSCode["Construction"] = "construction";
    NAICSCode["Manufacturing"] = "manufacturing";
    NAICSCode["WholesaleTrade"] = "wholesale_trade";
    NAICSCode["RetailTrade"] = "retail_trade";
    NAICSCode["TransportationWarehousing"] = "transportation_warehousing";
    NAICSCode["Information"] = "information";
    NAICSCode["FinanceInsurance"] = "finance_insurance";
    NAICSCode["RealEstateRentalAndLeasing"] = "real_estate_rental_and_leasing";
    NAICSCode["ProfessionalScientificTechnicalServices"] = "professional_scientific_technical_services";
    NAICSCode["ManagementCompaniesAndEnterprises"] = "management_companies_and_enterprises";
    NAICSCode["AdministrativeWasteManagementServices"] = "administrative_waste_management_services";
    NAICSCode["EducationalServices"] = "educational_services";
    NAICSCode["HealthCareAndSocialAssistance"] = "health_care_and_social_assistance";
    NAICSCode["ArtsEntertainmentRecreation"] = "arts_entertainment_recreation";
    NAICSCode["AccommodationFoodServices"] = "accommodation_food_services";
    NAICSCode["OtherServices"] = "other_services";
    NAICSCode["PublicAdministration"] = "public_administration";
})(NAICSCode = exports.NAICSCode || (exports.NAICSCode = {}));
exports.NAICS_INDUSTRY_GROUP_OPTIONS = {
    [NAICSCode.AgricultureForestry]: 'Agriculture, Forestry, Fishing and Hunting',
    [NAICSCode.Mining]: 'Mining',
    [NAICSCode.Utilities]: 'Utilities',
    [NAICSCode.Construction]: 'Construction',
    [NAICSCode.Manufacturing]: 'Manufacturing',
    [NAICSCode.WholesaleTrade]: 'Wholesale Trade',
    [NAICSCode.RetailTrade]: 'Retail Trade',
    [NAICSCode.TransportationWarehousing]: 'Transportation and Warehousing',
    [NAICSCode.Information]: 'Information',
    [NAICSCode.FinanceInsurance]: 'Finance and Insurance',
    [NAICSCode.RealEstateRentalAndLeasing]: 'Real Estate Rental and Leasing',
    [NAICSCode.ProfessionalScientificTechnicalServices]: 'Professional, Scientific, and Technical Services',
    [NAICSCode.ManagementCompaniesAndEnterprises]: 'Management of Companies and Enterprises',
    [NAICSCode.AdministrativeWasteManagementServices]: 'Administrative and Waste Management Services',
    [NAICSCode.EducationalServices]: 'Educational Services',
    [NAICSCode.HealthCareAndSocialAssistance]: 'Health Care and Social Assistance',
    [NAICSCode.ArtsEntertainmentRecreation]: 'Arts, Entertainment, and Recreation',
    [NAICSCode.AccommodationFoodServices]: 'Accommodation and Food Services',
    [NAICSCode.OtherServices]: 'Other Services',
    [NAICSCode.PublicAdministration]: 'Public Administration',
};
exports.NAICS_INDUSTRY_GROUP_SELECT_OPTIONS = (0, legacy_ui_1.selectOptionsFromMap)(exports.NAICS_INDUSTRY_GROUP_OPTIONS);
//# sourceMappingURL=industries.js.map